(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gridState = new WeakMap();
    const slideSelector = '.hero__media-wrapper, picture.hero__media, svg.hero__media';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const getSlides = (grid) =>
      Array.from(grid.children).filter((child) => child.matches(slideSelector));

    const getVisibleSlides = (grid) =>
      getSlides(grid).filter((slide) => {
        const style = window.getComputedStyle(slide);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });

    const syncVideoPlayback = (slide, active) => {
      slide.querySelectorAll('video').forEach((video) => {
        if (active) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    };

    const setActiveSlide = (slides, index) => {
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        syncVideoPlayback(slide, active);
      });
    };

    const setupGrid = (grid) => {
      const existingState = gridState.get(grid);

      if (existingState?.timer) {
        window.clearInterval(existingState.timer);
      }

      const slides = getVisibleSlides(grid);
      let index = existingState?.index || 0;

      if (slides.length === 0) {
        grid.classList.remove('hero-carousel-initialized');
        gridState.delete(grid);
        return;
      }

      if (index >= slides.length) {
        index = 0;
      }

      grid.classList.add('hero-carousel-initialized');
      getSlides(grid).forEach((slide) => {
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', 'true');
      });
      setActiveSlide(slides, index);

      const state = { index, timer: null };

      if (slides.length > 1 && !reducedMotion.matches) {
        state.timer = window.setInterval(() => {
          const currentSlides = getVisibleSlides(grid);

          if (currentSlides.length <= 1) {
            setupGrid(grid);
            return;
          }

          state.index = (state.index + 1) % currentSlides.length;
          setActiveSlide(currentSlides, state.index);
        }, 5000);
      }

      gridState.set(grid, state);
    };

    const setup = (root = document) => {
      root.querySelectorAll('.hero__media-grid').forEach(setupGrid);
    };

    const setupAll = () => setup(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll, { once: true });
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', (event) => setup(event.target));
    reducedMotion.addEventListener('change', setupAll);
    window.addEventListener('resize', setupAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
